"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Add from foundation/Add
 * @trackcomponent
 */
export const PlusIcon = createSVGIcon(
  <>
    <path d="M9 18L9 0" stroke="currentColor" />
    <path d="M18 9L0 9" stroke="currentColor" />
  </>,
  "PlusIcon",
  { viewBox: "0 0 18 18" }
);
